import type { ComponentType, JSX } from 'preact'
import he from 'https://esm.sh/he@1.2.0'

interface Props extends JSX.HTMLAttributes {
    html: string
    as?: keyof JSX.IntrinsicElements
}

function RenderHTML({ html, as = 'div', ...restProps }: Props) {
    const Component = as as unknown as ComponentType<JSX.HTMLAttributes>

    const decodedHtml = html.replace(/<pre>([\s\S]*?)<\/pre>/gi, (_, p1) => {
        return `<pre>${he.decode(p1)}</pre>`
    })

    return (
        <Component
            dangerouslySetInnerHTML={{ __html: decodedHtml }}
            {...restProps}
            class={`${restProps.class ?? ''} [&>*:empty]:h-5`}
        />
    )
}

export default RenderHTML
